import React, { useContext } from "react";
import { withRouter } from "react-router-dom";
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../styles/theme";
import GenericCard from "./GenericCard";
import { darken } from "polished";
import { GlobalContext } from "../context/GlobalState";

const CircleAddButton = ({ history }) => {
  const { clearCurrentSpotlight } = useContext(GlobalContext);

  const handleClick = () => {
    clearCurrentSpotlight();
    history.push("/build");
  };

  return (
    <div onClick={handleClick} className={noUnderline}>
      <GenericCard style={container}>
        <div className="plus">
          <div className="vert"></div>
          <div className="horiz"></div>
        </div>
        <div className="desktop-text">
          <p>New Spotlight</p>
        </div>
      </GenericCard>
    </div>
  );
};

export default withRouter(CircleAddButton);

const container = css`
  background-color: ${colors.brandColor};
  height: 30px;
  width: 30px;
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  transition-property: background-color;
  transition-duration: 0.2s;
  cursor: pointer;

  &:hover {
    background-color: ${darken(0.1, colors.brandColor)};
  }

  .plus {
    position: relative;

    .vert,
    .horiz {
      border-radius: 40px;
      background-color: white;
      height: 4px;
      width: 16px;
    }
    .vert {
      position: absolute;
      top: 0px;
      transform: rotate(90deg);
    }
  }

  .desktop-text {
    display: none;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: unset;
    border-radius: 40px;
    padding: 2px 20px;

    .desktop-text {
      display: block;
      p {
        color: white;
        font-weight: bold;
        font-size: ${textSizes.intermediate};
        margin-left: 8px;
      }
    }
  }
`;

const noUnderline = css`
  text-decoration: none;
`;
